const Footer = {
  data: {
    footerSelector: ".js-footer",
    complianceLinkId: "compliance_link",
  },

  init() {
    this.setFooterHeight();
    this.setComplianceLink();
  },

  setFooterHeight() {
    const footer = document.querySelector(this.data.footerSelector);
    // document.body.contains() because document.contains() doesn't work in IE
    if (document.body.contains(footer)) {
      const footerHeight = footer.clientHeight;
      document.documentElement.style.setProperty("--footer-height", `${footerHeight}px`);
    }
  },

  setComplianceLink() {
    const complianceLink = document.getElementById(this.data.complianceLinkId);

    if (!complianceLink) {
      console.warn("Compliance link does not exist.");
      return;
    }

    console.log("Compliance link exists.");

    complianceLink.addEventListener("click", (event) => {
      event.preventDefault();

      if (window.__uspapi) {
        console.log("InMobi uspapi is available.");
        window.__uspapi('displayUspUi', 1, function(data, status) {
          console.log(data, status);
        });
      } else {
        console.warn("InMobi US Privacy Manager API is not available.");
      }
    });
  }
};
export default Footer;
